import { GridColDef } from "@mui/x-data-grid-pro";
import { GKClientDataGrid } from "components";
import { useGetFeePlanHistoryQuery } from "store/features/Revenue/FeePlan";
import { extraColumnsField, matchDate } from "utils/helpers";

interface Props {
  portfolioId: string;
}

const FeePlanHistory = (props: Props) => {
  const { portfolioId } = props;

  const { data, isFetching } = useGetFeePlanHistoryQuery(portfolioId);

  const columns: GridColDef[] = [
    {
      ...extraColumnsField(
        `Fee Plan (${data?.data?.length})`,
        "feePlan",
        250,
        1,
      ),
      //   renderCell: (params) => {
      //     return (
      //       <Typography display={"flex"} alignItems={"center"} gap={1}>
      //         {params?.row?.feePlan}{" "}
      //         <Box>
      //           <StatusField
      //             statusString="CURRENT PLAN"
      //             styles={{
      //               padding: "4px 8px",
      //               borderRadius: "4px",
      //               border: "1px solid var(--white)",
      //               background: "var(--grey-50)",
      //               fontSize: 10,
      //               fontWeight: 600,
      //               color: "var(--grey-700)",
      //             }}
      //           />
      //         </Box>
      //       </Typography>
      //     );
      //   },
    },
    {
      ...extraColumnsField("Start Date", "startDate", 100, 1),
      valueGetter: (params) => matchDate(params?.row?.startDate),
    },
    {
      ...extraColumnsField("End Date", "endDate", 100, 1),
      valueGetter: (params) => matchDate(params?.row?.endDate),
    },
  ];

  return (
    <GKClientDataGrid
      loading={isFetching}
      columns={columns}
      rows={data?.data || []}
      name="portfolioFeePlans"
      maxHeight={"calc(100vh - 682px)"}
    />
  );
};

export default FeePlanHistory;
